export const emailRegex = RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);

export const numberRegex = RegExp(/^(0|[1-9][0-9]*)$/);

export const stringRegex = RegExp(/[A-Z]/gi);

export const dateRegex = RegExp(/\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])*/);

export const DataType = RegExp(/\D+/g);
